import styled from 'styled-components/native';

import { ScrollableContainer } from 'components/Containers';
import { Text } from 'components/Text';
import { UniversalButton } from 'components/UniveralButtons';
import Image, { ResizeMode } from 'cross-platform/Image';

export const LimitWidth = styled.View`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 60px 24px;
`;

export const LogoContainer = styled.View`
  flex-direction: column-reverse;
  height: 25%;
`;
export const Logo = styled(Image)``;

export const BackgroundImage = styled(Image).attrs({
  fit: ResizeMode.cover,
})`
  width: 100%;
  height: 100%;
  position: absolute;
`;

export const TextContainer = styled.View`
  flex-direction: column;
  height: 45%;
  max-width: 500px;
`;

// TODO: define the colors of the texts in the theme - find alignment with the Design team
export const FormattedText = styled(Text)`
  color: black;
  text-align: center;
  align-self: center;
`;

export const ButtonContainer = styled.View`
  display: flex;
  flex-direction: column;
  padding-horizontal: 30px;
  height: 25%;
`;

export const NHSButtonSection = styled.View`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const NHSErrorContainer = styled.View`
  margin-top: auto;
  padding-bottom: 12px;
`;

export const NHSButtonRow = styled.View`
  flex-direction: row;
  width: 100%;
  align-items: stretch;
`;

export const NHSButtonCell = styled.View`
  flex: 1;
  padding-horizontal: 4px;
`;

export const NHSButton = styled(UniversalButton)`
  min-width: 0;
  font-size: 16px;
  font-weight: bold;
  padding-left: 6px;
  padding-right: 6px;
`;

export const LoginSplashScreenScroll = styled(ScrollableContainer).attrs({
  contentContainerStyle: {
    flexGrow: 1,
    alignItems: 'center',
  },
})`
  width: 100%;
`;
